import { JOB_BOARD_ENDPOINTS } from '@/core/collections/job-boards/job-board.endpoints';

export const MEDIA_LIBRARY_ENDPOINTS = {
   GET_ALL: (jobBoardId: number) => `${JOB_BOARD_ENDPOINTS.GET_BY_ID(jobBoardId)}/media`,
   GET_BY_ID: (jobBoardId: number, mediaId: number) => `${JOB_BOARD_ENDPOINTS.GET_BY_ID(jobBoardId)}/media/${mediaId}`,
   CREATE: (jobBoardId: number) => `${JOB_BOARD_ENDPOINTS.GET_BY_ID(jobBoardId)}/media`,
   UPDATE: (jobBoardId: number, mediaId: number) => `${JOB_BOARD_ENDPOINTS.GET_BY_ID(jobBoardId)}/media/${mediaId}`,
   DELETE: (jobBoardId: number, mediaId: number) => `${JOB_BOARD_ENDPOINTS.GET_BY_ID(jobBoardId)}/media/${mediaId}`,
};
